export enum UserStatus {
    USER = 'Utilisateur',
    OWNER = 'Titulaire',
}
